var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.764 2.63h5.435c1.001 0 1.812.811 1.812 1.812V13.5c0 1-.811 1.812-1.812 1.812H7.764c-1 0-1.812-.812-1.812-1.812V9.877h.302v.905a.906.906 0 0 0 1.546.641l1.812-1.812a.906.906 0 0 0 0-1.28L7.8 6.517a.906.906 0 0 0-1.546.64v.907h-.302V4.442c0-1 .811-1.812 1.812-1.812zM5.95 8.065V6.253h-1.81V4.442A3.624 3.624 0 0 1 7.763.818h5.435a3.624 3.624 0 0 1 3.624 3.624V13.5a3.624 3.624 0 0 1-3.624 3.623H7.764a3.624 3.624 0 0 1-3.624-3.623v-1.812h1.811V9.877h-1.81v1.812h-.002V9.877H1.724a.906.906 0 1 1 0-1.812h2.415V6.253h.001v1.812h1.811z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.818 .818)",
    d: "M0 0h16.364v16.364H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.8735d34ffbef15c72d05242a10f1ae95.svg";
export { ForwardRef as ReactComponent };